import { useEffect, useState } from 'react';

/**
 * One breakpoint, shared with app.css: at 720px and under the app is the
 * phone layout of the 2026-09-14 mobile design - the pages in a bottom tab
 * bar, cards instead of tables, the drill-down as a bottom sheet. Same data,
 * same rules; only what is drawn changes. 720 rather than the mock's 640:
 * the desktop header does not fit between the two, and the P&L grid already
 * stacks there.
 */
export const PHONE_QUERY = '(max-width: 720px)';

const matches = (): boolean =>
  typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia(PHONE_QUERY).matches;

export function useIsPhone(): boolean {
  const [phone, setPhone] = useState<boolean>(matches);
  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const mq = window.matchMedia(PHONE_QUERY);
    const on = () => setPhone(mq.matches);
    mq.addEventListener('change', on);
    return () => mq.removeEventListener('change', on);
  }, []);
  return phone;
}
